const defaultLoaders = {
    charts: () => import('../alpine/charts'),
    datepicker: () => import('../alpine/datepicker'),
    flatpickr: async () => {
        const [{ default: flatpickr }, { default: languages }] = await Promise.all([
            import('flatpickr'),
            import('flatpickr/dist/l10n'),
        ]);

        return { flatpickr, languages };
    },
    wysiwyg: () => import('../alpine/wysiwyg'),
};

export const registerOptionalUiComponents = async (
    Alpine,
    { loaders = defaultLoaders, root = document } = {},
) => {
    const registrations = [];

    if (root.querySelector('[x-data^="charts"]')) {
        registrations.push(
            loaders.charts().then(({ default: charts }) => {
                Alpine.data('charts', charts);
            }),
        );
    }

    if (root.querySelector('[x-data^="datepicker"]')) {
        registrations.push(
            loaders.datepicker().then(({ default: datepicker }) => {
                Alpine.data('datepicker', datepicker);
            }),
        );
    }

    if (root.querySelector('[x-data*="$flatpickr"]')) {
        registrations.push(
            loaders.flatpickr().then(({ flatpickr, languages }) => {
                Alpine.magic('flatpickr', () => flatpickr);
                Alpine.magic('flatpickrLanguages', () =>
                    Object.fromEntries(
                        Object.entries(languages).map(([key, language]) => [
                            key,
                            {
                                ...language,
                                rangeSeparator: ' - ',
                            },
                        ]),
                    ),
                );
            }),
        );
    }

    if (root.querySelector('[x-data^="wysiwyg"]')) {
        registrations.push(
            loaders.wysiwyg().then(({ default: wysiwyg }) => {
                Alpine.data('wysiwyg', wysiwyg);
            }),
        );
    }

    await Promise.all(registrations);
};
